module.exports = __webpack_public_path__ + "img/ChristmasHorsies.a914b919.jpg";